import { Language } from "@fidget/common/models/language";
import { Translations } from "./locales/en";
import { TypedFormattedMessage, TypedHTMLFormattedMessage } from "./TypedReactIntl";
import { assertUnreachable } from "../utils/ts-utils";

export type L10nData = Translations;
export class L10n extends TypedFormattedMessage {}
export const L10nHtml = TypedHTMLFormattedMessage;
export type L10nId = keyof L10nData;

export const getMessages = async (language: Language): Promise<L10nData> => {
  switch (language) {
    case Language.EN:
      return import("./locales/en").then((module) => module.translations);
    case Language.PL:
      return import("./locales/pl").then((module) => module.translations);
    case Language.KA:
      return import("./locales/ka").then((module) => module.translations);
    case Language.ES:
      return import("./locales/es").then((module) => module.translations);
    default:
      assertUnreachable(language);
      return import("./locales/en").then((module) => module.translations);
  }
};

export { intl } from "./TypedIntl";
